export const checkText = (inputLabel) => {
    const input = inputLabel.querySelector(".input-container__input");

    const acceptText = () => {
        const checkText = input.value
        checkText ? inputLabel.classList.remove('input-container--error') : inputLabel.classList.add('input-container--error')
        return checkText
    }
    return {
        acceptText
    }  
}